import React, { useState, useEffect, useCallback, useRef } from 'react'
import '../StyleSheets/ManualValidation.css'
import imgSelfie from '../Images/selfie.png'
import imgPendingManualValidation from '../Images/pending-manual-validation.png'
import imgFrontPicture from '../Images/frontid.png'
import imgBackPicture from '../Images/backid.png'
import { Link, useNavigate } from 'react-router-dom'
import useModalCreditRequest from '../Hooks/useModalCreditRequest'
import ModalCreditRequest from './ModalCreditRequest'
import TarsServices from '../Services/TarsServices'
import imgLoader from '../Images/MeddipayLoaderEllipsis.gif'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useCreditRequestAuth } from '../Context/useCreditRequestAuth'
import dayjs from 'dayjs';
import DocumentAutoCapture from './DocumentAutoCapture'
import FaceAutoCapture from './FaceAutoCapture'
import { GenerateJWTSessionCustomer } from '../Services/SoraService';
import FaceDetection from '@mediapipe/face_detection';
import { Loader, ThemeProvider, Flex, View, Alert } from '@aws-amplify/ui-react';
import FaceLiveness from './FaceLiveness'
import SmileLiveness from './SmileLiveness'


const IdentityValidation = () => {
    const TRIES_FOR_ACTIVATE_QUESTION = 2;// UNO MENOS DE LO QUE SE REQUIERA. EJ: SI SE QUIEREN 2 INTENTOS ENTONCES PONER 1
    const TRIES_FOR_DEACTIVATE_PHOTOS = 4;// UNO MENOS DE LO QUE SE REQUIERA. EJ: SI SE QUIEREN 5 INTENTOS ENTONCES PONER 4






    const [faceInDocument, setFaceInDocument] = useState(true);
    const [isOpenModalPicture, openModalPicture, closeModalPicture] = useModalCreditRequest(false);
    // const [isOpenModalFile, openModalFile, closeModalFile] = useModalCreditRequest(false);
    const navigate = useNavigate();
    const [selfiePicture, setSelfiePicture] = useState("");
    const [showDivSelfiePicture, setShowDivSelfiePicture] = useState(false);
    const [showAwsSelfie, setShowAwsSelfie] = useState(true);
    const [sending, setSending] = useState(false);
    const [idFrontPicture, setIdFrontPicture] = useState("");
    const [showDivIdFrontPicture, setShowDivIdFrontPicture] = useState(false);

    const [idBackPicture, setIdBackPicture] = useState("");
    const [showDivIdBackPicture, setShowDivIdBackPicture] = useState(false);
    // const [facingMode, setFacingMode] = useState(FACING_MODE_USER);

    // const [activeCamera, setActiveCamera] = useState(false);
    // const imgFileRef = React.useRef();

    const [screenWidth,] = useState(window.innerWidth);
    // const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    //const webcamRef = React.useRef(null);

    const { SetManualValidationCustomerFromJWT, SavePhotoCustomerFromJWT, IdentityValidation } = TarsServices();
    const MySwal = withReactContent(Swal);
    const { logout, clearRequest, getStorage, setStorage } = useCreditRequestAuth();

    const [myCanvas, setMyCanvas] = useState(null);
    const myCanvasRef = useCallback(node => setMyCanvas(node));

    const [myCanvas2, setMyCanvas2] = useState(null);
    const myCanvasRef2 = useCallback(node => setMyCanvas2(node));


    const [myCanvas3, setMyCanvas3] = useState(null);
    const myCanvasRef3 = useCallback(node => setMyCanvas3(node));

    let request = getStorage("request");
    const [tryCount, setTryCount] = useState(0);

    const [createLivenessApiData, setCreateLivenessApiData] = useState(null);
    const [faceLivenessResult, setFaceLivenessResult] = useState(null);

    useEffect(() => {
        setSending(true)
        navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {

            stream.getTracks().forEach(function (track) {
                track.stop();
            });

            setTimeout(() => {
                setSending(false)

                MySwal.fire({
                    html: `<b>Para el proceso de toma de fotos ten en cuenta las siguientes indicaciones a la hora de tomarte la selfie 🤳</b>
                    <br/>
                    <br/>
    
                    <ul style="text-align:left;font-size: 15px;">
                    <li>No usar tapabocas, gafas, gorras ni audífonos</li>
                    <li>La foto debe estar enfocada</li>
                    <li>La foto debe tener buena iluminación</li>
                     <li>La foto NO debe tener brillos</li>
                   `,
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#00a9eb",
                })

            }, 4000);



        }).catch((err) => {
            setSending(false)
            MySwal.fire({
                title: "SE NECESITAN PERMISOS PARA ACCEDER A LA CAMARA",

                html: <>
                    <br></br><svg width="90" height="84" viewBox="0 0 90 84" fill="none" xmlns="http://www.w3.org/2000/svg" className="sc-dmfyKz evCKng"><path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M5.63623 32.771C5.63623 28.3527 9.21795 24.771 13.6362 24.771H26.0604C28.7057 24.771 31.18 23.4633 32.6702 21.2777L34.7544 18.2208C36.2446 16.0352 38.7189 14.7275 41.3643 14.7275H47.6362H53.9082C56.5535 14.7275 59.0278 16.0352 60.518 18.2208L62.6023 21.2777C64.0925 23.4633 66.5668 24.771 69.2121 24.771H81.6362C86.0545 24.771 89.6362 28.3527 89.6362 32.771V69.7275C89.6362 74.1458 86.0545 77.7275 81.6362 77.7275H13.6362C9.21795 77.7275 5.63623 74.1458 5.63623 69.7275V32.771ZM65.3754 50.0754C65.3754 60.0165 57.3165 68.0754 47.3754 68.0754C37.4342 68.0754 29.3754 60.0165 29.3754 50.0754C29.3754 40.1342 37.4342 32.0753 47.3754 32.0753C57.3165 32.0753 65.3754 40.1342 65.3754 50.0754ZM23.3319 36.4232C25.541 36.4232 27.3319 34.6323 27.3319 32.4232C27.3319 30.214 25.541 28.4232 23.3319 28.4232C21.1227 28.4232 19.3319 30.214 19.3319 32.4232C19.3319 34.6323 21.1227 36.4232 23.3319 36.4232Z" fill="#B3BBC6"></path><path d="M57.9239 16.1126C56.9723 13.1219 54.1947 11.0908 51.0563 11.0908H36.9437C33.8053 11.0908 31.0277 13.1219 30.0761 16.1126C29.1245 19.1033 26.3469 21.1343 23.2085 21.1343H9.30435C5.27027 21.1343 2 24.4046 2 28.4386V66.7865C2 68.1705 2.38492 69.4646 3.05355 70.5676M13.8696 74.0908H45.3696M67.5307 21.1343H78.6957C82.7297 21.1343 86 24.4046 86 28.4386V66.7865C86 70.8206 82.7297 74.0908 78.6957 74.0908H53.1304" stroke="#B3BBC6" strokeWidth="3" strokeLinecap="round"></path><path d="M25.8374 49.0633C25.7049 48.1826 25.6362 47.2809 25.6362 46.3633C25.6362 36.4222 33.6951 28.3633 43.6362 28.3633C44.6905 28.3633 45.7236 28.4539 46.7281 28.6278M29.5841 57.6133C32.8829 61.7284 37.9519 64.3633 43.6362 64.3633C53.5774 64.3633 61.6362 56.3044 61.6362 46.3633C61.6362 40.6789 59.0013 35.61 54.8862 32.3112" stroke="#B3BBC6" strokeWidth="3" strokeLinecap="round"></path><path d="M23.9546 30.5459C23.9546 31.9266 22.8353 33.0459 21.4546 33.0459C20.0739 33.0459 18.9546 31.9266 18.9546 30.5459C18.9546 29.1652 20.0739 28.0459 21.4546 28.0459C22.8353 28.0459 23.9546 29.1652 23.9546 30.5459Z" stroke="#B3BBC6" strokeWidth="3"></path><path d="M3.81836 82L83.8183 2" stroke="#B3BBC6" strokeWidth="3" strokeLinecap="round"></path></svg>
                    <br></br><br></br> <br></br><b>Por favor permite el uso de la camara y refresca la pagina</b>
                    <br></br>
                    <br></br>

                </>,
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: false,
                showDenyButton: false,
                allowEnterKey: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
            })

        });



    }, []);

    const URL_API = process.env.REACT_APP_URL_REKOGNITION;//"https://identityvalidationdemo.azurewebsites.net"
    const GetSessionId = async () => {
        setSending(true);

        const response = await fetch(URL_API + "/api/GetSessionId");
        const data = await response.json();

        setCreateLivenessApiData({ sessionId: data.sessionId });

        // setCreateLivenessApiData({ sessionId:"provocar_error"});

        setSending(false);

    };

    const handleAnalysisComplete = async () => {
        const response = await fetch(URL_API + "/api/VerifyFaceLiveness?SessionId=" + createLivenessApiData.sessionId);
        const data = await response.json();

        if (data.status === "SUCCEEDED" && data.confidence >= 70) {
            setFaceLivenessResult(data);
            handleFacePhotoTaken({
                image: data.referenceImage,
                width: data.boundingBox.width,
                height: data.boundingBox.height,
                left: data.boundingBox.left,
                top: data.boundingBox.top
            })
        }
        else if (data.status === "SUCCEEDED" && data.confidence < 70) {
            setShowDivSelfiePicture(false);
            setShowAwsSelfie(true);
            setShowDivIdFrontPicture(false);
            setShowDivIdBackPicture(false);
            closeModalPicture();

            MySwal.fire({
                html: "No se pudo verificar el rostro. Asegúrate de que sea tu rostro y no una fotografía",
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: "#00a9eb",
            })
        } else {

            setShowDivSelfiePicture(false);
            setShowAwsSelfie(true);
            setShowDivIdFrontPicture(false);
            setShowDivIdBackPicture(false);
            closeModalPicture();

            MySwal.fire({
                html: "Se generó un error al verificar el rostro. Inténtalo de nuevo",
                icon: 'error',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: "#00a9eb",
            })
        }

    };

    const resetAll = async () => {
        setCreateLivenessApiData(null);
        setShowDivSelfiePicture(false);
        setShowAwsSelfie(true);
        setShowDivIdFrontPicture(false);
        setShowDivIdBackPicture(false);
        // setActiveCamera(false);
        closeModalPicture();
    }

    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    useEffect(() => {
        if (idFrontPicture) {

            let faceDetection = new FaceDetection.FaceDetection({
                locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
            })

            faceDetection.setOptions({ model: 'short' })

            const myImage = new Image();
            myImage.src = idFrontPicture;

            faceDetection.send({ image: myImage }).catch(error => {
                console.log("ERROR CONTROLADO CAPTURA ROSTRO")
                console.log(error)
                setFaceInDocument(true)
            })

            faceDetection.onResults(res => {
                if (res.detections.length > 0)
                    setFaceInDocument(true)
                else
                    setFaceInDocument(false)
            })
        }
    }, [idFrontPicture]);

    const validatePictures = async () => {

        if (!faceInDocument) {

            Swal.fire({
                title: "No se detectó el rostro en la cédula frontal",
                html: "Asegúrate que el rostro de la cédula sea totalmente visible, evita reflejos y hologramas que dificulten la comparación de rostros. Usa buena iluminación y mantén firme la cédula para mayor nitidez.",
                showCancelButton: false,

                confirmButtonText: 'Aceptar',
                confirmButtonColor: "#00a9eb",
                icon: 'warning'
            })

            return
        }

        setSending(true);
        let image1;
        let image2;
        let image3;

        if (typeof selfiePicture === "object") {
            image1 = selfiePicture;
        }
        else {
            image1 = new File([b64toBlob(selfiePicture.split(",")[1], "image/jpeg")], `selfie_device_${dayjs().format("YYYYMMDD_HH_mm_ss")}.jpg`, {
                type: "image/jpeg"
            });
        }

        if (typeof idFrontPicture === "object") {
            image2 = idFrontPicture;
        }
        else {
            image2 = new File([b64toBlob(idFrontPicture.split(",")[1], "image/jpeg")], `front_device_${dayjs().format("YYYYMMDD_HH_mm_ss")}.jpg`, {
                type: "image/jpeg"
            });
        }

        if (typeof idBackPicture === "object") {
            image3 = idBackPicture;
        }
        else {
            image3 = new File([b64toBlob(idBackPicture.split(",")[1], "image/jpeg")], `back_device_${dayjs().format("YYYYMMDD_HH_mm_ss")}.jpg`, {
                type: "image/jpeg"
            });
        }


        var bodyFormData1 = new FormData();

        bodyFormData1.append('Selfie.File', image1);
        bodyFormData1.append('CedulaFront.File', image2);
        bodyFormData1.append('CedulaBack.File', image3);

        bodyFormData1.append('Cedula', request.cusDocument);
        bodyFormData1.append('cusFullName', `${request.cusFirstName} ${request.cusSecondName} ${request.cusFirstSurname} ${request.cusSecondSurname}`);
        bodyFormData1.append('Email', request.cusEmail);

        SavePhotoCustomerFromJWT(bodyFormData1).then(res => {

            if (res.status === 200) {

                IdentityValidation({
                    documentType: request.cusDocumentType,
                    document: request.cusDocument,
                    firstName: `${request.cusFirstName} ${request.cusSecondName}`.trim(),
                    lastName: `${request.cusFirstSurname} ${request.cusSecondSurname}`.trim(),
                    selfiePicture: selfiePicture.split(",")[1],
                    frontPicture: idFrontPicture.split(",")[1],
                    gender: request.cusGender,
                    birthDate: `${request.year}-${request.month}-${request.day}`,
                    backPicture: idBackPicture.split(",")[1]
                }).then(res2 => {

                    let data = JSON.parse(res2.data.data);

                    if (res2.status === 200) {

                        setTryCount(i => i + 1);


                        const { faceSimilarity, faceMatch, identificationMatch, nameMatch } = data;


                        if (!faceMatch || !identificationMatch || !nameMatch) {//ROSTRO NO COINCIDE
                            setSending(false);
                            MySwal.fire({
                                html: <ModalErrorIV msg={"Validación de identidad fallida"}
                                    faceSimilarity={Number(faceSimilarity)}
                                    faceMatch={faceMatch}
                                    identificationMatch={identificationMatch}
                                    nameMatch={nameMatch}
                                    modify={false}></ModalErrorIV>,
                                icon: 'error',
                                showCancelButton: false,
                                showConfirmButton: false,
                                showDenyButton: false,
                                allowOutsideClick: false,
                                allowEnterKey: false,
                                allowEscapeKey: false

                            })
                        }
                        // else if (!identificationMatch) {//IDENTIFICACION NO COINCIDE
                        //     setSending(false);
                        //     MySwal.fire({
                        //         html: <ModalErrorIV msg={"La identificación digitada no coincide con la identificación de la foto"}
                        //             faceSimilarity={Number(faceSimilarity)}
                        //             modify={true}></ModalErrorIV>,
                        //         icon: 'error',
                        //         showCancelButton: false,
                        //         showConfirmButton: false,
                        //         showDenyButton: false,
                        //         allowOutsideClick: false,
                        //         allowEnterKey: false,
                        //         allowEscapeKey: false

                        //     })
                        // }
                        // else if (!nameMatch) {//NOMBRE NO COINCIDE
                        //     setSending(false);
                        //     MySwal.fire({
                        //         html: <ModalErrorIV msg={"Los nombres digitados no coincide con los nombres de la foto"}
                        //             faceSimilarity={Number(faceSimilarity)}
                        //             modify={true}></ModalErrorIV>,
                        //         icon: 'error',
                        //         showCancelButton: false,
                        //         showConfirmButton: false,
                        //         showDenyButton: false,
                        //         allowOutsideClick: false,
                        //         allowEnterKey: false,
                        //         allowEscapeKey: false

                        //     })
                        // }

                        else if (identificationMatch && faceMatch && nameMatch) {

                            if (request.IVP) {

                                setStorage("request", {
                                    ...request,
                                    IVP: false,
                                    state: 10
                                });

                                navigate("/ApplicationRequest");
                            }
                            else {
                                GenerateJWTSessionCustomer({ token: data.token }).then(resjwt => {
                                    setSending(false);
                                    if (resjwt.status === 200 || resjwt.status === 201) {



                                        setStorage("request", {
                                            ...request,
                                            state: 9,
                                            identityValidated: true
                                        });

                                        setStorage("creditRequestToken", JSON.parse(resjwt.data.data).Token, { path: "/" })
                                        setStorage("expiredTime", Date.parse(JSON.parse(resjwt.data.data).ExpiredTime), { path: "/" })

                                        navigate("/Dashboard");




                                    } else {

                                        MySwal.fire({
                                            html: "Error al generar el token",
                                            icon: 'error'
                                        })
                                    }

                                })
                            }

                        }

                    } else {


                        if (data && data.ExistingFace === 1) {
                            logout();
                            clearRequest();
                            navigate("/");
                        }

                        setSending(false);
                        MySwal.fire({
                            html: res2.data.message,
                            icon: 'error'
                        })

                    }

                })





            } else {
                setSending(false);
                MySwal.fire({
                    html: res.data.message,
                    icon: 'error'
                })

            }
        })


    }



    const handleFacePhotoTaken = (imageData, content) => {

        // const imageUrl = URL.createObjectURL(imageData.image);

        const context = myCanvas3.getContext('2d');


        var image = new Image();
        //image.src = "abc.png";
        image.src = "data:image/jpg;base64," + imageData.image;
        image.id = "img-prueba3"

        image.onload = function () {
            // crop from 0,0, to 250,150
            var cropX = imageData.left - (imageData.width * 0.15);
            var cropY = imageData.top - (imageData.height * 0.2);



            var cropWidth = imageData.width + (imageData.width * 0.3);
            var cropHeight = imageData.height + (imageData.height * 0.3);



            //resize our canvas to match the size of the cropped area
            myCanvas3.width = cropWidth;
            myCanvas3.height = cropHeight;

            //fill canvas with cropped image
            context.drawImage(image, cropX, cropY, cropWidth, cropHeight, 0, 0, myCanvas3.width, myCanvas3.height);
            setSelfiePicture(myCanvas3.toDataURL("image/jpeg"));
            setShowDivSelfiePicture(false);
            setShowAwsSelfie(true);

            closeModalPicture();

            // setSending(true)

            // setTimeout(() => {
            //     setSending(false);

            //     closeModalPicture();
            // }, 2000);


        }



        // closeModalPicture();

    }


    const handleFacePhotoTakenInnovatrics = (imageData, content) => {

        // console.log(imageData)

        imageData = imageData[0]//solo para smile liveness
        // console.log(imageData)

        if (imageData.data.detection.confidence < 0.70) {
            setShowDivSelfiePicture(false);
            setShowAwsSelfie(true);
            setShowDivIdFrontPicture(false);
            setShowDivIdBackPicture(false);
            closeModalPicture();

            MySwal.fire({
                html: "No se pudo verificar el rostro. Asegúrate de que sea tu rostro y no una fotografía",
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: "#00a9eb",
            })

            return;
        }

        const imageUrl = URL.createObjectURL(imageData.image);

        const context = myCanvas3.getContext('2d');


        var image = new Image();
        //image.src = "abc.png";
        image.src = imageUrl;
        image.id = "img-prueba3"

        image.onload = function () {
            // crop from 0,0, to 250,150
            var cropX = imageData.data.detection.topLeft.x - 150;
            var cropY = imageData.data.detection.topLeft.y - 200;



            var cropWidth = (imageData.data.detection.bottomRight.x - imageData.data.detection.topLeft.x) + 300;
            var cropHeight = (imageData.data.detection.bottomRight.y - imageData.data.detection.topLeft.y) + 300;



            //resize our canvas to match the size of the cropped area
            myCanvas3.width = cropWidth;
            myCanvas3.height = cropHeight;

            //fill canvas with cropped image
            context.drawImage(image, cropX, cropY, cropWidth, cropHeight, 0, 0, myCanvas3.width, myCanvas3.height);
            setSelfiePicture(myCanvas3.toDataURL("image/jpeg"));
            setShowDivSelfiePicture(false);
            setShowAwsSelfie(true);
            setSending(true)

            setTimeout(() => {
                setSending(false);

                closeModalPicture();
            }, 2000);


        }



        // closeModalPicture();

    }

    const handleDocumentPhotoTaken = (imageData, content) => {

        const imageUrl = URL.createObjectURL(imageData.image);


        if (showDivIdFrontPicture) {

            const context = myCanvas.getContext('2d');


            let image = new Image();
            //image.src = "abc.png";
            image.src = imageUrl;
            image.id = "img-prueba"

            image.onload = function () {
                // crop from 0,0, to 250,150
                var cropX = imageData.data.detection.topLeft.x;
                var cropY = imageData.data.detection.topLeft.y;
                var cropWidth = imageData.data.detection.topRight.x - imageData.data.detection.topLeft.x;
                var cropHeight = imageData.data.detection.bottomRight.y - imageData.data.detection.topRight.y;

                //resize our canvas to match the size of the cropped area
                myCanvas.width = cropWidth;
                myCanvas.height = cropHeight;

                //fill canvas with cropped image
                context.drawImage(image, cropX, cropY, cropWidth, cropHeight, 0, 0, myCanvas.width, myCanvas.height);
                setIdFrontPicture(myCanvas.toDataURL("image/jpeg"));
                setShowDivIdFrontPicture(false);

                setSending(true)

                setTimeout(() => {
                    setSending(false)

                    closeModalPicture();
                }, 2000);

            }

        }
        else {
            const context = myCanvas2.getContext('2d');


            let image = new Image();
            //image.src = "abc.png";
            image.src = imageUrl;
            image.id = "img-prueba2"

            image.onload = function () {
                // crop from 0,0, to 250,150
                var cropX = imageData.data.detection.topLeft.x;
                var cropY = imageData.data.detection.topLeft.y;
                var cropWidth = imageData.data.detection.topRight.x - imageData.data.detection.topLeft.x;
                var cropHeight = imageData.data.detection.bottomRight.y - imageData.data.detection.topRight.y;

                //resize our canvas to match the size of the cropped area
                myCanvas2.width = cropWidth;
                myCanvas2.height = cropHeight;

                //fill canvas with cropped image
                context.drawImage(image, cropX, cropY, cropWidth, cropHeight, 0, 0, myCanvas2.width, myCanvas2.height);
                setIdBackPicture(myCanvas2.toDataURL("image/jpeg"));
                setShowDivIdBackPicture(false);

                setSending(true)

                setTimeout(() => {
                    setSending(false)

                    closeModalPicture();
                }, 2000);
            }
        }


        // closeModalPicture();


    };

    const handleError = useCallback((error) => {
        console.log("ERROR CONTROLADO INNOVATRICS");
        console.log(error);
    }, []);


    const ManualValidation = () => {
        setSending(true)
        SetManualValidationCustomerFromJWT(request.cusEmail, `${request.cusFirstName} ${request.cusSecondName} ${request.cusFirstSurname} ${request.cusSecondSurname}`, request.cusDocument).then(res => {
            setSending(false)
            if (res.status === 200) {
                MySwal.fire({
                    html: `<b>Estamos validando tu información</b>
                                <br/>
                                <br/>
                                <img style="width:100px" src="` + String(imgPendingManualValidation) + `"/>
                                <br/>
                                <br/>
                                <p>En estos momentos nuestro equipo se encuentra validando la información que acabas de suministrarnos, en breve nos comunicaremos contigo para continuar con tu proceso.</p>
                                `,
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#00a9eb",
                    allowEnterKey: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false
                })


                if (request.IVP) {

                    setStorage("request", {
                        ...request,
                        IVP: false,
                        state: 9
                    });

                    navigate("/Dashboard");
                }
                else {
                    logout();
                    clearRequest();
                }


            }
            else {
                MySwal.fire({
                    html: res.data.message,
                    icon: 'error'
                })
            }
        })


    }

    const ModalErrorIV = ({ msg, modify, faceSimilarity, faceMatch, identificationMatch, nameMatch }) => {

        return <>

            <b>{msg}</b>
            <br />
            <br />

            {/* <table style={{ margin: "0 auto" }}>
                <tr>
                    <td style={{textAlign:"left"}}>Coincidencia del rostro ({Math.round(faceSimilarity)}%)&nbsp; </td>
                    <td>{faceMatch ? <i style={{ color: "green" }} className="bi bi-check-circle-fill"></i> : <i style={{ color: "red" }} className="bi bi-x-circle-fill"></i>} </td>
                </tr>
                <tr>
                    <td style={{textAlign:"left"}}>Coincidencia del número de identificación&nbsp; </td>
                    <td> {identificationMatch ? <i style={{ color: "green" }} className="bi bi-check-circle-fill"></i> : <i style={{ color: "red" }} className="bi bi-x-circle-fill"></i>}</td>
                </tr>
                <tr>
                    <td style={{textAlign:"left"}}>Coincidencia de los nombres&nbsp; </td>
                    <td> {nameMatch ? <i style={{ color: "green" }} className="bi bi-check-circle-fill"></i> : <i style={{ color: "red" }} className="bi bi-x-circle-fill"></i>}</td>
                </tr>
            </table>

            <br />
            <br /> */}
            Puedes escoger alguna de las siguientes opciones para continuar tu proceso:
            <br />
            <br />
            <table style={{ width: "100%" }}>
                <tbody>

                    {tryCount <= TRIES_FOR_DEACTIVATE_PHOTOS && <tr>
                        <td style={{ padding: "5px" }}>
                            <button type="button" style={{ width: "250px" }} className="btn btn-mp" onClick={() => {
                                // setSelfiePicture("");
                                // setIdFrontPicture("");
                                // setIdBackPicture("");
                                MySwal.close();
                            }}>Tomar las fotos nuevamente</button></td>
                    </tr>}


                    <tr>
                        <td style={{ padding: "5px" }}>
                            <button type="button" style={{ width: "250px" }} className="btn btn-mp" onClick={() => {
                                window.open("https://wa.me/" + encodeURI("+573011633330"))
                                // MySwal.close();
                            }}>Enviar fotos por WhatsApp</button></td>
                    </tr>


                    {modify && <tr>
                        <td style={{ padding: "5px" }}>
                            <button type="button" style={{ width: "250px" }} className="btn btn-mp" onClick={() => {
                                setStorage("request", {
                                    ...request,
                                    state: 0,
                                    updateCustomer: true
                                });
                                MySwal.close();
                                navigate("/");
                            }}>Modificar datos</button></td>
                    </tr>
                    }

                    {faceSimilarity > 20 && <tr>
                        <td style={{ padding: "5px" }}>
                            <button type="button" style={{ width: "250px" }} className="btn btn-mp" onClick={() => {
                                setStorage("request", {
                                    ...request,
                                    state: 13
                                });
                                MySwal.close();
                                navigate("/QuestionsVerification");
                            }}>Validacion mediante preguntas de seguridad</button></td>
                    </tr>}

                    <tr>
                        <td style={{ padding: "5px" }}>
                            <button type="button" style={{ width: "250px" }} className="btn btn-mp" onClick={() => {
                                MySwal.close();
                                ManualValidation();
                            }}>Solicitar revisión humana</button></td>
                    </tr>


                </tbody>
            </table>


        </>

    }

    return (
        <>

            <table id="manual-validation-table">
                <tbody>
                    {!request.IVP ? <tr>
                        <td style={{ textAlign: "center", color: "gray" }} colSpan={2}>
                            <h3>4/4</h3>
                        </td>
                    </tr> : <tr>
                        <td style={{ textAlign: "center", color: "gray" }} colSpan={2}>
                            <h3>Validación de identidad</h3>

                        </td>
                    </tr>}
                    <tr>
                        <td>
                            <div className="divPicture">

                                <div onClick={!selfiePicture ? (e) => {
                                    // setFacingMode(FACING_MODE_USER);
                                    setShowDivSelfiePicture(true);
                                    setShowAwsSelfie(true);
                                    setShowDivIdFrontPicture(false);
                                    setShowDivIdBackPicture(false);
                                    // setActiveCamera(true);
                                    // if (showAwsSelfie)
                                    //     GetSessionId();
                                    openModalPicture();
                                } : undefined}>
                                    <img src={!selfiePicture ? imgSelfie : selfiePicture} className="imgPicture" style={{ width: !selfiePicture ? "70px" : "200px" }}></img>

                                    <canvas id="my-canvas3" ref={myCanvasRef3} style={{ display: "none" }}></canvas>
                                    {selfiePicture && (<i className="bi bi-trash manual-validation-icon" onClick={(e) => {
                                        e.stopPropagation();
                                        // imgFileRef.current.value = "";
                                        setSelfiePicture("");
                                    }

                                    }></i>)}
                                    <br />
                                    {!selfiePicture ? "Selfie" : ""}
                                </div>

                            </div>


                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="divPicture" style={{ borderColor: faceInDocument ? "unset" : "red" }}>
                                <div onClick={!idFrontPicture ? (e) => {
                                    // setFacingMode(FACING_MODE_ENVIRONMENT);
                                    setShowDivSelfiePicture(false);
                                    setShowAwsSelfie(true);
                                    setShowDivIdFrontPicture(true);
                                    setShowDivIdBackPicture(false);
                                    // setActiveCamera(true);
                                    openModalPicture();
                                } : undefined}>
                                    <img src={!idFrontPicture ? imgFrontPicture : idFrontPicture} className="imgPicture" style={{ width: !idFrontPicture ? "85px" : "200px" }}></img>

                                    {/* {idFrontPicture && <FaceDetectionImg src={idFrontPicture} setFaceInDocument={setFaceInDocument} />} */}
                                    <canvas id="my-canvas" ref={myCanvasRef} style={{ display: "none" }}></canvas>

                                    {idFrontPicture && (< i className="bi bi-trash manual-validation-icon" onClick={(e) => {
                                        e.stopPropagation();
                                        // imgFileRef.current.value = "";
                                        setIdFrontPicture("");
                                    }

                                    }></i>)}
                                    <br />
                                    {!idFrontPicture ? "Frontal cedula" : ""}
                                </div>

                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="divPicture">
                                <div onClick={!idBackPicture ? (e) => {
                                    // setFacingMode(FACING_MODE_ENVIRONMENT);
                                    setShowDivSelfiePicture(false);
                                    setShowAwsSelfie(true);
                                    setShowDivIdFrontPicture(false);
                                    setShowDivIdBackPicture(true);
                                    // setActiveCamera(true);
                                    openModalPicture();
                                } : undefined}>
                                    <img src={!idBackPicture ? imgBackPicture : idBackPicture} className="imgPicture" style={{ width: !idBackPicture ? "85px" : "200px" }}></img>
                                    <canvas id="my-canvas2" ref={myCanvasRef2} style={{ display: "none" }}></canvas>
                                    {idBackPicture && (<i className="bi bi-trash manual-validation-icon" onClick={(e) => {
                                        e.stopPropagation();
                                        // imgFileRef.current.value = "";
                                        setIdBackPicture("");
                                    }

                                    }></i>)}

                                    <br />
                                    {!idBackPicture ? "Reverso cedula" : ""}
                                </div>

                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                                <Link to="/Profile" onClick={() => {

                                    if (request.IVP) {
                                        setStorage("request", {
                                            ...request, state: 9
                                        })
                                    }
                                    else {
                                        setStorage("request", {
                                            ...request, state: 4
                                        })
                                    }

                                }}>
                                    <button type="button" className="btn btn-light" style={{ marginRight: "20px" }}>Regresar</button>
                                </Link>
                                {selfiePicture && idFrontPicture && idBackPicture && (
                                    <button className="btn btn-primary" onClick={validatePictures}>Continuar</button>
                                )}
                                {/* <button className="btn btn-primary" onClick={validatePictures}>Continuar</button> */}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table >
            {sending &&
                (
                    <div className="my-loader">
                        <div className="my-loader-container">
                            <img src={imgLoader} alt="loader"></img>

                        </div>
                    </div>
                )
            }



            <ModalCreditRequest isOpen={isOpenModalPicture} closeModal={(e) => {
                setShowDivSelfiePicture(false);
                setShowAwsSelfie(true);
                setShowDivIdFrontPicture(false);
                setShowDivIdBackPicture(false);
                // setActiveCamera(false);
                setCreateLivenessApiData(null)
                closeModalPicture();

            }}>
                <div style={{ margin: "0 auto" }}>
                    <div className="manual-validation-cam">

                        <div>
                            <div style={{ marginTop: "20px", marginBottom: "20px", width: "100%" }}>

                                <div style={{ width: "100%", }}>
                                    <h3 style={{ color: "gray", marginBottom: "0" }}>
                                        {showDivSelfiePicture ? "Foto selfie" : showDivIdFrontPicture ? "Foto frontal documento" : showDivIdBackPicture ? "Foto reverso documento" : ""}
                                    </h3>
                                    <i className="bi bi-x" style={{ cursor: "pointer", fontSize: "35px", position: "absolute", right: "5px", top: "7px" }} onClick={() => {
                                        setShowDivSelfiePicture(false);
                                        setShowAwsSelfie(true);
                                        setShowDivIdFrontPicture(false);
                                        setShowDivIdBackPicture(false);
                                        // setActiveCamera(false);
                                        setCreateLivenessApiData(null)
                                        closeModalPicture();
                                    }}></i>
                                </div>



                            </div>

                        </div>

                        <div style={{ margin: "0 auto", width: screenWidth <= 600 ? "100%" : "50%", position: "relative", overflow: "hidden" }}>

                            {/* {
                                showDivSelfiePicture && showAwsSelfie ?

                                    createLivenessApiData && <FaceLiveness
                                        GetSessionId={GetSessionId}
                                        handleAnalysisComplete={handleAnalysisComplete}
                                        resetAll={resetAll}
                                        createLivenessApiData={createLivenessApiData}
                                        setShowAwsSelfie={setShowAwsSelfie}
                                        sending={sending} />



                                    : showDivSelfiePicture && !showAwsSelfie ? <FaceAutoCapture onPhotoTaken={handleFacePhotoTakenInnovatrics} onError={handleError} /> : <></>
                            } */}

                            {/* {showDivSelfiePicture ? <FaceAutoCapture onPhotoTaken={handleFacePhotoTakenInnovatrics} onError={handleError} /> : <></>} */}

                            {showDivSelfiePicture ? <SmileLiveness onCompleteSmile={handleFacePhotoTakenInnovatrics} onErrorSmile={handleError} /> : <></>}

                            {
                                (showDivIdFrontPicture || showDivIdBackPicture) ?
                                    <DocumentAutoCapture onPhotoTaken={handleDocumentPhotoTaken} onError={handleError} />
                                    : <></>
                            }



                        </div>

                    </div>


                </div>
            </ModalCreditRequest>




        </>

    );
}




export default IdentityValidation;